module.exports = __webpack_public_path__ + "static/media/Prerna Tulsiani.0472796a.jpg";